import React from 'react';
import { Grid, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatPercentage, formatWaterActivity } from '../../utils/format';
import LabeledGridItem from '../atoms/LabeledGridItem';
var RoasterTransportToWarehouse = function (_a) {
    var offerList = _a.offerList;
    var t = useTranslation().t;
    var roasterCountryTransportToWarehouse = React.useMemo(function () {
        if (!offerList.transportToWarehouses || !offerList.importedWarehouse)
            return;
        return offerList.transportToWarehouses.find(function (transportToWarehouse) {
            var _a;
            return (transportToWarehouse.warehouse.id === ((_a = offerList.importedWarehouse) === null || _a === void 0 ? void 0 : _a.id));
        });
    }, [offerList]);
    var renderImportedWaterActivity = React.useMemo(function () {
        var ttw = roasterCountryTransportToWarehouse;
        if (!ttw || !ttw.importWaterActivity)
            return '';
        if (!ttw.exportWaterActivity)
            return formatWaterActivity(ttw.importWaterActivity);
        return "".concat(formatWaterActivity(ttw.importWaterActivity), "(").concat(formatWaterActivity((parseFloat(ttw.importWaterActivity) -
            parseFloat(ttw.exportWaterActivity))
            .toFixed(2)
            .toString()), ")");
    }, [roasterCountryTransportToWarehouse]);
    var renderImportedMoistureContent = React.useMemo(function () {
        var ttw = roasterCountryTransportToWarehouse;
        if (!ttw || !ttw.importMoistureContent)
            return '';
        if (!ttw.exportMoistureContent)
            return formatPercentage(ttw.importMoistureContent);
        return "".concat(formatPercentage(ttw.importMoistureContent), "(").concat(formatPercentage((parseFloat(ttw.importMoistureContent) -
            parseFloat(ttw.exportMoistureContent))
            .toFixed(1)
            .toString()), ")");
    }, [roasterCountryTransportToWarehouse]);
    if (!roasterCountryTransportToWarehouse)
        return null;
    return (React.createElement(Grid, { container: true },
        React.createElement(Grid, { item: true, xs: 12, sm: 6, sx: { mt: 4 } },
            React.createElement(Box, { component: "h4", sx: {
                    color: function (theme) { return theme.customPalette.text.disabled; },
                    typography: function (theme) { return theme.customTypography.overline; },
                    mb: 1,
                    mt: 0,
                } }, t('labels.exported')),
            React.createElement(LabeledGridItem, { label: t('pages.transportToWarehouse.waterActivity'), value: formatWaterActivity(roasterCountryTransportToWarehouse.exportWaterActivity || '') }),
            React.createElement(LabeledGridItem, { label: t('pages.transportToWarehouse.moistureContent'), value: formatPercentage(roasterCountryTransportToWarehouse.exportMoistureContent || '') })),
        React.createElement(Grid, { item: true, xs: 12, sm: 6, sx: { mt: 4 } },
            React.createElement(Box, { component: "h4", sx: {
                    color: function (theme) { return theme.customPalette.text.disabled; },
                    typography: function (theme) { return theme.customTypography.overline; },
                    mb: 1,
                    mt: 0,
                } }, t('labels.imported')),
            React.createElement(LabeledGridItem, { label: t('pages.transportToWarehouse.waterActivity'), value: renderImportedWaterActivity }),
            React.createElement(LabeledGridItem, { label: t('pages.transportToWarehouse.moistureContent'), value: renderImportedMoistureContent }))));
};
export default RoasterTransportToWarehouse;
